import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from './navbar/Navbar';
import Footer from './footer/Footer';
import { storage } from "../utils/firebase"; 
import { ref, getDownloadURL } from 'firebase/storage';
import '../styles/home.css'; 
import IntroductionSlider from './sliders/IntroductionSlider';
import TripCarousel from './carousel/TripCarousel';
import TripInspiration from './carousel/TripInspiration';
import Delicacies from './carousel/Delicacies';
import FeedbackForm from './feedback/FeedbackForm';

const HomePage = () => {
  const [backgroundImage, setBackgroundImage] = useState('');
  const [overlayImages, setOverlayImages] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  
  const navigate = useNavigate();

  const searchableItems = [
    { name: 'Bacoor Eco-Park', path: '/bacoorpark' },
    { name: 'Molino Dam', path: '/molinodam' },
    { name: 'Senyong\'s Museum', path: '/senyongsmuseum' },
    { name: 'Strike Gymnasium', path: '/strikegym' },
    { name: 'Zapote Bridge', path: '/tulayzapote' },
    { name: 'Prinza Dam', path: '/prinzadam' },
    { name: 'Fr. Mariano Gomes Monument', path: '/marianogomes' },
    { name: 'Kainan sa Balsa', path: '/kainanbalsa' },
    { name: 'Seafood Terminal', path: '/seafoodterminal' },
    { name: 'Digman Halo-Halo', path: '/digmanhalo' },
    { name: 'Monument of Love', path: '/monumentlove' },
    { name: 'General Edilberto Evangelista Monument', path: '/edilbertomonument' },
    { name: 'Justice Buenaventura A. Ocampo Ancestral House', path: '/justicehouse' },
    { name: 'Bahay ni Tisa', path: '/bahaytisa' },
    { name: 'St. Michael the Archangel Church', path: '/michaelchurch' },
    { name: 'St. Ezekiel Moreno Park', path: '/stezekiel' },
    { name: 'Sto. Niño de Molino Parish Church', path: '/stonino' },
    { name: 'NOMO', path: '/nomo' },
    { name: 'SOMO', path: '/somo' },
    { name: 'SM City Bacoor', path: '/smbacoor' },
    { name: 'SM City Molino', path: '/smmolino' },
    { name: 'R. Antonio\'s', path: '/rantonio' },
    { name: 'Main Square Bacoor', path: '/mainsquare' },
    { name: 'RFC Molino Mall', path: '/rfcmall' },
    { name: 'Funnside Ningnangan Bacoor', path: '/funnside' },
    { name: 'Brick Wood PH', path: '/brickwood' },
    { name: 'Cocina sa Garaje Gervasio', path: '/cocina' },
    { name: 'Cavite State University - Bacoor Campus', path: '/cvsu' },
  ];

  useEffect(() => {
    const imageRef = ref(storage, 'home/bacoorpic.jpg');
    getDownloadURL(imageRef)
      .then((url) => {
        setBackgroundImage(url);
      })
      .catch((error) => {
        console.error('Error fetching background image from Firebase Storage:', error);
      });

    // Fetch overlay images from Firebase Storage
    const overlayImageRefs = [
      ref(storage, 'home/2.png'),
      ref(storage, 'home/1.png'),
      ref(storage, 'home/4.png'),
    ];

    const fetchOverlayImages = async () => {
      const urls = await Promise.all(overlayImageRefs.map((ref) => getDownloadURL(ref)));
      setOverlayImages(urls);
    };

    fetchOverlayImages();
  }, []);


  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const results = searchableItems.filter((item) =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredResults(results);
    } else {
      setFilteredResults([]);
    }
  };

  const handleResultClick = (path) => {
    navigate(path); 
  };

  return (
    <div className="home-page">
      <Navbar />
      <TripCarousel />
      
      <div
        className="hero-section"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        
        <div className="overlay">
      
          <h1 className="hero-title">Explore Bacoor: History, Culture, and Adventure</h1>
          <div className="search-bar">
            <input
              type="text12"
              placeholder="What are you looking for?"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button type="submit">Search</button>

            {filteredResults.length > 0 && (
              <div className="search-results">
                {filteredResults.map((item) => (
                  <div
                    key={item.path}
                    className="search-result-item"
                    onClick={() => handleResultClick(item.path)}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          
          {/* Display overlay images inline */}
         
        </div>
      </div>
      <IntroductionSlider />
      <TripInspiration />
      <Delicacies />
      <FeedbackForm />
      <Footer />
    </div>
  );
};

export default HomePage;
